import React, { useEffect, useState } from 'react';

import $ from 'jquery';
import mainURL from '../../config/environment';

import Typography from '@mui/material/Typography';

import Grid from '@mui/material/Grid';
import backgroundLines from '../../assets/linesbackground.png';

import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material';
import { Box } from '@mui/system';
import Footer from '../../components/footer/footer';
import MapCard from '../../components/cards/mapCard';

export default function Maps(props) {
  const [maps, setMaps] = useState([]);
  const { handleDrawerClose } = props;
  const navigate = useNavigate();
  const theme = useTheme();

  const handleNavigate = (mapId) => (event) => {
    navigate(`/maps/${mapId}`);
    handleDrawerClose();
  };

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('userInfo')).token;
    const clientId = JSON.parse(localStorage.getItem('userInfo')).clientId;
    let isSubscribed = true;
    //handleShowNotification("info", "Loading users");
    $.ajax({
      method: 'GET',
      url: `${mainURL}map/${clientId}/get-by-client`,
      contentType: 'application/json',
      headers: {
        Authorization: 'Bearer ' + token,
      },
    })
      .done((res) => {
        if (isSubscribed) {
          setMaps(res);
        }
      })
      .fail((res) => {});
    return () => (isSubscribed = false);
  }, []);

  return (
    <Box
      height="100%"
      sx={{
        backgroundImage: `url(${backgroundLines})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'repeat-y',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        backgroundColor: '#eef8fe',
      }}
    >
      <Box>
        <Box sx={{ p: 2, pb: 0 }}>
          <Typography variant="h5" sx={{ color: theme.palette.gray.dark, fontWeight: '600' }}>
            Welcome to the Americas Project Status Center
          </Typography>
          <Typography variant="body2" sx={{ color: theme.palette.gray.main }}>
            View all available updates for your projects here
          </Typography>
        </Box>

        <Grid container sx={{ pl: 2 }}>
          {maps.map((map) => (
            <Grid key={map.id} sx={{ p: 2 }} item xs={12} sm={6} md={4}>
              <MapCard map={map} handleNavigate={handleNavigate} />
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box>
        <Footer />
      </Box>
    </Box>
  );
}
